app.factory('authService', ['$http', '$q', 'localStorageService', '$location', '$timeout', function ($http, $q, localStorageService, $location, $timeout) {

	var authServiceFactory = {};

	var _authentication = {
		isAuth: false,
		userName: "",
		nome: ""
	};

	var _captcha = async function () {
		return new Promise(resolve => {
            try {
				grecaptcha.enterprise.ready(function () {
					grecaptcha.enterprise.execute(appConfig.siteKey, { action: 'login' }).then(function (token) {
						document.getElementById('g-recaptcha-response').value = token;
						resolve(token)
					});
				});
            } catch (e) {
				resolve("")
            }
		})
	};

	var _login = async function (loginData, epCodigo) {
		const data = {
			grant_type: "password",
			username: loginData.userName,
			password: loginData.password,
			captchaToken: await _captcha()
		}

		if (loginData.useRefreshTokens) {
			data["client_id"] = appConfig.clientId;
		}

		//EPCodigo
		if (epCodigo) data.EPCodigo = epCodigo;

		const dto = new URLSearchParams(data).toString()

		var deferred = $q.defer();

		$http.post(appConfig.serviceBase + 'token', dto, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {

			_redirectPatner(response.data.partner);

			var refreshToken = "";
			var useRefreshTokens = false;

			if (loginData.useRefreshTokens) {
				refreshToken = response.data.refresh_token;
				useRefreshTokens = true;
			}
			else {
				refreshToken = "";
				useRefreshTokens = false;
			}
			
			var objJson = {
				token: response.data.access_token,
				userName: loginData.userName,
				nome: response.data.nome,
				role: response.data.role,
				userID: parseInt(response.data.userid),
				empresa: response.data.empresa,
				empresas: JSON.parse(response.data.empresas),
				cargoID: parseInt(response.data.cargoid),
				refreshToken: refreshToken,
				useRefreshTokens: useRefreshTokens,
				epCodigoBMP: response.data.EPCodigo,
				nomeEmpresaBMP: response.data.NomeEmpresa
			};

			if (response.data.empresa !== null) {
				objJson.cargoID = parseInt(response.data.empresa.split('|')[2]);
			}

			var encaes = CryptoJS.AES.encrypt(angular.toJson(objJson), appConfig.aes).toString();
			localStorageService.set('authorizationData', encaes);

			//Grava Cookie
			jsCookies.set("foundation.token", objJson.token, 1);

			_authentication.isAuth = true;
			_authentication.userName = loginData.userName;
			_authentication.useRefreshTokens = loginData.useRefreshTokens;
			_authentication.nome = loginData.nome;

			//Variaveis globais
			appConfig.userID = objJson.userID;
			appConfig.empresaID = objJson.empresa;
			appConfig.empresas = objJson.empresas;
			appConfig.cargoID = objJson.cargoID;
			appConfig.epCodigoBMP = objJson.epCodigoBMP;
			appConfig.nomeEmpresaBMP = objJson.nomeEmpresaBMP;

			deferred.resolve(response.data);

		}, function (response) {
			_logout();
			deferred.reject(response.data);
		});

		return deferred.promise;
	};

	var _redirectPatner = function (partner) {
		if (partner == 'True') {
			var ambienteHomologacao = appConfig.serviceBase.indexOf(':99') > -1 ||
				appConfig.serviceBase.indexOf('http://localhost') > -1 ||
				appConfig.serviceBase.indexOf('bmpteste.moneyp.com.br') > -1;

			var url = ambienteHomologacao ? 'https://partner.bmpdigital.moneyp.dev.br/' : 'https://partner.bmpdigital.moneyp.com.br/';

			window.location.replace(url);
		}
	}

	var _forgot = async function (email) {

		var data = {};
		data.Email = email;
		data.CaptchaToken = await _captcha();

		var deferred = $q.defer();

		$http.post(appConfig.serviceBase + 'api/Auth/Forgot', data).then(function (response) {
			deferred.resolve(response);
		}, function (err, status) {
			deferred.reject(err);
		});

		return deferred.promise;

	};

	var _validateResetToken = async function (token, email) {
		var data = {}
		data.Token = token;
		data.Email = email;
		data.CaptchaToken = await _captcha();

		var deferred = $q.defer();

		$http.post(appConfig.serviceBase + 'api/Auth/ValidateResetToken', data).then(function (response) {
			deferred.resolve(response);
		}, function (err, status) {
			deferred.reject(err);
		});

		return deferred.promise;
	}

	var _resetSenha = async function (token, email, senha) {
		var data = {}
		data.Token = token;
		data.Email = email;
		data.Senha = senha;
		data.CaptchaToken = await _captcha();

		var deferred = $q.defer();

		$http.post(appConfig.serviceBase + 'api/Auth/ResetSenha', data).then(function (response) {
			deferred.resolve(response);
		}, function (err, status) {
			deferred.reject(err);
		});

		return deferred.promise;
	}

	var _logout = function () {

		var deferred = $q.defer();

		setTimeout(function () {
			localStorageService.remove('authorizationData');
			_authentication.isAuth = false;
			_authentication.userName = "";
			jsCookies.set("foundation.token", "", 1);
			deferred.resolve();
		}, 1000);

		return deferred.promise;

	};

	var _fillAuthData = function () {
		var authData = appConfig.reverse(localStorageService.get('authorizationData'));
		if (authData) {
			_authentication.isAuth = true;
			_authentication.userName = authData.userName;
		}
	};

	var _refreshToken = function () {
		var deferred = $q.defer();

		var authData = appConfig.reverse(localStorageService.get('authorizationData'));

		if (authData) {
			if (authData.useRefreshTokens) {

				var data = "grant_type=refresh_token&refresh_token=" + authData.refreshToken + "&client_id=" + appConfig.clientId;

				localStorageService.remove('authorizationData');

				$http.post(appConfig.serviceBase + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {

					var objJson = {
						token: response.data.access_token,
						userName: response.data.userName,
						nome: response.data.nome,
						role: response.data.role,
						userID: parseInt(response.data.userid),
						empresa: response.data.empresa,
						empresas: JSON.parse(response.data.empresas),
						cargoID: parseInt(response.data.cargoid),
						refreshToken: response.data.refresh_token,
						useRefreshTokens: true,
						epCodigoBMP: response.data.EPCodigo,
						nomeEmpresaBMP: response.data.NomeEmpresa
					};
					var encaes = CryptoJS.AES.encrypt(angular.toJson(objJson), appConfig.aes).toString();
					localStorageService.set('authorizationData', encaes);

					//Variaveis globais
					appConfig.userID = objJson.userID;
					appConfig.empresaID = objJson.empresa;
					appConfig.empresas = objJson.empresas;
					appConfig.cargoID = objJson.cargoID;
					appConfig.epCodigoBMP = objJson.epCodigoBMP;
					appConfig.nomeEmpresaBMP = objJson.nomeEmpresaBMP;

					deferred.resolve(response);

				}, function (err, status) {
					_logout();
					deferred.reject(err);
				});
			}
		}
		else {
			deferred.reject();
		}

		return deferred.promise;
	};

	var _obtainAccessToken = function (externalData) {

		var deferred = $q.defer();

		$http.get(appConfig.serviceBase + 'api/account/ObtainLocalAccessToken', { params: { provider: externalData.provider, externalAccessToken: externalData.externalAccessToken } }).then(function (response) {

			localStorageService.set('authorizationData', {
				token: response.data.access_token,
				userName: response.data.userName,
				refreshToken: "",
				useRefreshTokens: false
			});

			_authentication.isAuth = true;
			_authentication.userName = response.data.userName;
			_authentication.useRefreshTokens = false;

			deferred.resolve(response);

		}, function (response) {
			_logOut();
			deferred.reject(response);
		});

		return deferred.promise;

	};

	var _redirectChangePassword = function (token, username) {
        $timeout(function () {
            $location.path('/resetsenha').search({ token: token, email: username });
        }, 4000);
    };

	var _handleErrorLogin = function (err, username) {
		let msgPadrao = "Usuário ou senha inválidos";
		let msgPadraoExpirada = "Senha expirada! <br/> Redirecionando para redefinição."
		switch (err.error) {
			case "CTL-001":
				// Usuário bloqueado. Motivo: O último login foi a mais que xx dias
				return err.error_description;

			case "CTL-002":
				// Senha expirada. Para continuar o acesso troque a senha
				_redirectChangePassword(err.error_uri, username)
				return msgPadraoExpirada;

			case "CTL-003":
				// Usuário Bloqueado
				return err.error_description;

			case "CTL-004":
				// Senha invalida
				return msgPadrao;
				
			case "CTL-005":
				// Senha invalida
				return msgPadrao;

			case "CTL-006":
				// Usuário invalido
				return msgPadrao;

			case "CTL-007":
				// Senha irá expirar em xx dias
				$timeout(function () {
					$location.path('/loginempresa');
				}, 4000);
				return err.error_description;

			case "invalid_grant":
				return err.error_description;
				
			default:
				return 'Ocorreu um erro inesperado.'
		}
	};

	var _getReferenceToken = function () {
		var deferred = $q.defer();

		$http.post(appConfig.serviceBase + 'api/Auth/ReferenceToken').then(function (response) {
			deferred.resolve(response);
		}, function (err, status) {
			deferred.reject(err);
		});

		return deferred.promise;
	};

	authServiceFactory.login = _login;
	authServiceFactory.logout = _logout;
	authServiceFactory.forgot = _forgot;
	authServiceFactory.validateResetToken = _validateResetToken;
	authServiceFactory.resetSenha = _resetSenha;
	authServiceFactory.fillAuthData = _fillAuthData;
	authServiceFactory.authentication = _authentication;
	authServiceFactory.redirectChangePassword = _redirectChangePassword;
	authServiceFactory.handleErrorLogin = _handleErrorLogin;
	authServiceFactory.captcha = _captcha;

	authServiceFactory.refreshToken = _refreshToken;
	authServiceFactory.obtainAccessToken = _obtainAccessToken;
	authServiceFactory.getReferenceToken = _getReferenceToken;

	return authServiceFactory;
}]);
